// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"74966020","307":"e4f88d17","436":"26a4e9c0","463":"4a9ffce0","531":"0b4821a8","593":"c929e06a","951":"1d1816a2"}[chunkId] + ".chunk.css";
};